const mixin = {
  data: () => ({
    items: [],
    loading: false
  }),
  computed: {
    noItemsFound() {
      return !this.loading && this.items.length === 0
    }
  }
}

export default mixin
